import "./Athlon.css";

const AthlonPage = () => {
  return (
    <iframe
      src="https://world.aldar.com/uae/dubai/athlon"
      className="iframe-fullscreen"
    ></iframe>
  );
};

export default AthlonPage;
